
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'VLoader',
  props: {
    loading: {
      type: Boolean,
      default: true,
    },
  },
});
